import React, {
  useState,
  useEffect,
} from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  TextField,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import Autocomplete from "@material-ui/lab/Autocomplete";

import { useAlert } from "react-alert";

import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EventIcon from "@material-ui/icons/Event";
import PersonIcon from "@material-ui/icons/Person";
import ReceiptIcon from "@material-ui/icons/Receipt";
import VisibilityIcon from "@material-ui/icons/Visibility";

import {
  AuctionListLimit,
  printLot,
} from "../../../adminModel/auctions";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  card: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    boxShadow: "none",
    overflow: "hidden",
    backgroundColor: "#fff",
  },

  sectionHeader: {
    padding: theme.spacing(2.25, 2.5),
    backgroundColor: "#fafafa",
  },

  sectionTitle: {
    fontWeight: 600,
    color: "#1f2937",
  },

  sectionSubtitle: {
    marginTop: 3,
    color: "#6b7280",
  },

  headerIcon: {
    width: 38,
    height: 38,
    minWidth: 38,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#eef2ff",
    color: theme.palette.primary.main,
    marginRight: 12,
  },

  content: {
    padding: theme.spacing(2.5),
  },

  field: {
    marginBottom: theme.spacing(2),

    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  lotField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },

    "& textarea": {
      lineHeight: 1.7,
    },
  },

  addOnsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },

  addOnsTitle: {
    fontWeight: 600,
    color: "#374151",
  },

  addOnRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.25),

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },

  addOnDescription: {
    flex: 2,

    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  addOnPrice: {
    flex: 1,

    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  addOnAction: {
    width: 38,
    height: 38,

    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-end",
    },
  },

  summaryBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.75),
    borderRadius: 10,
    border: "1px solid #e5e7eb",
    backgroundColor: "#f8fafc",
  },

  summaryTitle: {
    fontWeight: 600,
    color: "#374151",
    marginBottom: theme.spacing(1),
  },

  summaryRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 0",
  },

  summaryLabel: {
    color: "#6b7280",
    fontSize: 13,
  },

  summaryValue: {
    color: "#111827",
    fontSize: 13,
    fontWeight: 600,
  },

  totalRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 10,
    marginTop: 8,
    borderTop: "1px solid #d1d5db",
  },

  totalLabel: {
    color: "#111827",
    fontSize: 14,
    fontWeight: 700,
  },

  totalValue: {
    color: "#111827",
    fontSize: 15,
    fontWeight: 700,
  },

  actionSection: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(2),
  },

  previewButton: {
    minHeight: 42,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    paddingLeft: 20,
    paddingRight: 20,
  },

  lotCount: {
    marginTop: theme.spacing(1.5),
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    backgroundColor: "#f8fafc",
    color: "#6b7280",
    fontSize: 13,
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const Views = () => {
  const classes = useStyles();
  const alert = useAlert();

  // =========================
  // STATE
  // =========================

  const [loading, setLoading] =
    useState(false);

  const [customerName, setName] =
    useState("");

  const [consignedName, setConsignedName] =
    useState("");

  const [commission, setCommission] =
    useState(0.05);

  const [geteventList, setEventList] =
    useState([]);

  const [lotNumberData, setLotNumber] =
    useState("");

  const [eventId, setEventId] =
    useState("");

  const [eventName, setEventName] =
    useState("");

  const [dateStart, setDateStart] =
    useState("");

  const [data1, setData1] =
    useState([]);

  const [totalSub, setTotalSub] =
    useState(0);

  // =========================
  // FETCH EVENTS
  // =========================

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const results =
          await AuctionListLimit();

        setEventList(
          results?.data || []
        );
      } catch (error) {
        console.error(
          "Fetch Error:",
          error
        );

        alert.error(
          "Failed to load events."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // =========================
  // EVENT SELECTION
  // =========================

  const handlepick = (
    event,
    value
  ) => {
    if (!value) {
      setEventName("");
      setEventId("");
      setDateStart("");
      setData1([]);
      setTotalSub(0);

      return;
    }

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const dateValue =
      value.date_start
        ? new Date(
            value.date_start.slice(
              0,
              10
            )
          )
        : null;

    setEventName(
      value.auction_name || ""
    );

    setDateStart(
      dateValue
        ? dateValue.toLocaleDateString(
            "en-US",
            options
          )
        : ""
    );

    setEventId(value.id);

    if (lotNumberData) {
      fetchLots(
        value.id,
        lotNumberData
      );
    } else {
      setData1([]);
      setTotalSub(0);
    }
  };

  // =========================
  // FETCH LOTS
  // =========================

  const fetchLots = async (
    id,
    lots
  ) => {
    try {
      const results =
        await printLot(
          lots,
          id
        );

      if (
        !results ||
        results === false
      ) {
        setData1([]);
        setTotalSub(0);

        return;
      }

      const sorted = [
        ...results,
      ].sort(
        (a, b) =>
          Number(
            a.lot_number || 0
          ) -
          Number(
            b.lot_number || 0
          )
      );

      setData1(sorted);

      const sum =
        results.reduce(
          (acc, curr) =>
            acc +
            parseInt(
              curr.hp || 0,
              10
            ),
          0
        );

      setTotalSub(sum);
    } catch (error) {
      console.error(
        "Fetch lots error:",
        error
      );

      setData1([]);
      setTotalSub(0);

      alert.error(
        "Failed to load lot details."
      );
    }
  };

  // =========================
  // LOT INPUT
  // =========================

  const handleLotInput = (
    event
  ) => {
    const val =
      event.target.value;

    setLotNumber(val);

    if (eventId) {
      fetchLots(
        eventId,
        val
      );
    }
  };

  // =========================
  // COMMISSION VALUE
  // =========================

  const commissionRate =
    parseFloat(
      commission || 0
    );

  const commissionAmount =
    totalSub *
    commissionRate;

  // =========================
  // FORMAT MONEY
  // =========================

  const formatMoney = (
    value
  ) => {
    return parseFloat(
      value || 0
    ).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }
    );
  };

  // =========================
  // ESCAPE HTML
  // =========================

  const escapeHtml = (
    value
  ) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    return String(value)
      .replace(
        /&/g,
        "&amp;"
      )
      .replace(
        /</g,
        "&lt;"
      )
      .replace(
        />/g,
        "&gt;"
      )
      .replace(
        /"/g,
        "&quot;"
      )
      .replace(
        /'/g,
        "&#039;"
      );
  };

  // =========================
  // PRINT PREVIEW
  // =========================

  const handlePrintPreview = () => {
    if (!eventId) {
      alert.error(
        "Please select an event first."
      );

      return;
    }

    if (
      !customerName.trim()
    ) {
      alert.error(
        "Please enter the commission name."
      );

      return;
    }

   

    if (
      !data1 ||
      data1.length === 0
    ) {
      alert.error(
        "Please enter valid lot numbers."
      );

      return;
    }

    const printWindow =
      window.open(
        "",
        "_blank",
        "width=1100,height=900"
      );

    if (!printWindow) {
      alert.error(
        "Please allow pop-ups for this page."
      );

      return;
    }

    const printDate =
      new Date().toLocaleString(
        "en-PH",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        }
      );

    // =========================
    // LOT ROWS
    // =========================

    const lotRows = data1
      .map(
        (value) => `
          <tr>

            <td
              style="
                border:0.5pt solid #000;
                padding:7px;
                text-align:center;
                font-size:11px;
                font-weight:600;
              "
            >
              ${escapeHtml(
                value.lot_number
              )}
            </td>

            <td
              style="
                border:0.5pt solid #000;
                padding:5px;
                text-align:center;
                vertical-align:middle;
              "
            >
              ${
                value.img_url
                  ? `
                    <img
                      src="${escapeHtml(
                        value.img_url
                      )}"
                      alt="lot"
                      style="
                        width:65px;
                        height:60px;
                        object-fit:contain;
                        display:block;
                        margin:0 auto;
                      "
                    />
                  `
                  : `
                    <span
                      style="
                        font-size:9px;
                        color:#777;
                      "
                    >
                      No Image
                    </span>
                  `
              }
            </td>

            <td
              style="
                border:0.5pt solid #000;
                padding:8px;
                text-align:center;
                font-size:10px;
              "
            >
              <div
                style="
                  font-weight:bold;
                  margin-bottom:3px;
                "
              >
                ${
                  value.artist ||
                  ""
                }
              </div>

              <div
                style="
                  font-style:italic;
                "
              >
                ${
                  value.title ||
                  ""
                }
              </div>
            </td>

            <td
              style="
                border:0.5pt solid #000;
                padding:8px;
                text-align:center;
                font-size:11px;
                font-weight:600;
              "
            >
              ${formatMoney(
                value.hp || 0
              )}
            </td>

          </tr>
        `
      )
      .join("");

    // =========================
    // FULL PRINT HTML
    // =========================

    printWindow.document.open();

    printWindow.document.write(`
      <!DOCTYPE html>

      <html>

        <head>

          <meta charset="UTF-8" />

          <title>
            Commission Receipt
          </title>

          <style>

            @page {
              size: A4 portrait;
              margin: 0;
            }

            * {
              box-sizing:
                border-box;
            }

            html,
            body {
              margin: 0;
              padding: 0;

              background:
                #e5e7eb;

              color: #000;
            }

            body {
              font-family:
                Arial,
                Helvetica,
                sans-serif;

              padding-bottom:
                40px;
            }


            /* =====================
               TOP BAR
            ===================== */

            .topbar {

              position:
                sticky;

              top: 0;

              z-index: 1000;

              width: 100%;

              height: 60px;

              padding:
                0 20px;

              background:
                #fff;

              border-bottom:
                1px solid #d1d5db;

              box-shadow:
                0 2px 8px
                rgba(
                  0,
                  0,
                  0,
                  0.08
                );

              display:
                flex;

              justify-content:
                flex-end;

              align-items:
                center;
            }


            .print-button {

              border: none;

              background:
                #1976d2;

              color: #fff;

              padding:
                10px 18px;

              border-radius:
                6px;

              font-family:
                Arial,
                sans-serif;

              font-size:
                14px;

              font-weight:
                600;

              cursor:
                pointer;
            }


            .print-button:hover {
              background:
                #1565c0;
            }


            /* =====================
               PAPER
            ===================== */

            .paper {

              width:
                210mm;

              min-height:
                297mm;

              margin:
                25px auto;

              padding:
                18mm;

              background:
                #fff;

              box-shadow:
                0 5px 25px
                rgba(
                  0,
                  0,
                  0,
                  0.15
                );
            }


            /* =====================
               HEADER
            ===================== */

            .header {

              display:
                flex;

              align-items:
                flex-start;

              justify-content:
                space-between;

              padding-bottom:
                12px;

              border-bottom:
                1px solid #000;
            }


            .logo {

              width:
                180px;

              height:
                auto;

              object-fit:
                contain;
            }


            .contact {

              text-align:
                right;

              font-size:
                10px;

              line-height:
                1.5;
            }


            .contact p {
              margin:
                0;
            }


            /* =====================
               TITLE
            ===================== */

            .document-title {

              text-align:
                center;

              font-size:
                18px;

              font-weight:
                700;

              margin:
                22px 0;

              letter-spacing:
                0.3px;
            }


            /* =====================
               INFO
            ===================== */

            .info {
              margin-bottom:
                18px;
            }


            .info-row {

              display:
                flex;

              margin-bottom:
                6px;

              font-size:
                12px;
            }


            .info-label {

              width:
                105px;

              font-weight:
                700;
            }


            .info-value {
              flex:
                1;
            }


            /* =====================
               DESCRIPTION
            ===================== */

            .description {

              font-size:
                12px;

              line-height:
                1.6;

              text-align:
                justify;

              margin:
                15px 0 20px;
            }


            .indent {
              padding-left:
                28px;
            }


            /* =====================
               TABLE
            ===================== */

            .receipt-table {

              width:
                100%;

              border-collapse:
                collapse;

              border:
                0.5pt solid #000;
            }


            .receipt-table th {

              border:
                0.5pt solid #000;

              padding:
                8px 6px;

              background:
                #f2f2f2;

              font-size:
                10px;

              font-weight:
                700;

              text-transform:
                uppercase;

              text-align:
                center;
            }


            .receipt-table td {

              page-break-inside:
                avoid;
            }


            .summary-label {

              border:
                0.5pt solid #000;

              padding:
                8px;

              text-align:
                right;

              font-size:
                10px;

              font-weight:
                600;

              text-transform:
                uppercase;
            }


            .summary-value {

              border:
                0.5pt solid #000;

              padding:
                8px;

              text-align:
                center;

              font-size:
                11px;
            }


            .total-label {

              border:
                0.5pt solid #000;

              padding:
                10px 8px;

              text-align:
                right;

              font-size:
                11px;

              font-weight:
                700;

              text-transform:
                uppercase;
            }


            .total-value {

              border:
                0.5pt solid #000;

              padding:
                10px 8px;

              text-align:
                center;

              font-size:
                12px;

              font-weight:
                700;
            }


            /* =====================
               SIGNATURE
            ===================== */

            .signature-wrapper {

              margin-top:
                70px;

              display:
                flex;

              justify-content:
                flex-end;

              page-break-inside:
                avoid;
            }


            .signature {

              width:
                220px;

              text-align:
                center;
            }


            .signature-line {

              width:
                220px;

              border-top:
                0.5pt solid #000;

              padding-top:
                5px;
            }


            .signature-label {

              font-size:
                10px;

              font-weight:
                700;

              text-transform:
                uppercase;
            }


            /* =====================
               ADDRESS
            ===================== */

            .address {

              text-align:
                center;

              margin-top:
                45px;

              font-size:
                10px;

              line-height:
                1.5;
            }


            .address p {
              margin:
                2px 0;
            }


            /* =====================
               PRINT
            ===================== */

            @media print {

              html,
              body {
                background:
                  #fff;
              }

              body {
                padding:
                  0;
              }

              .topbar {
                display:
                  none !important;
              }

              .paper {

                width:
                  210mm;

                min-height:
                  297mm;

                margin:
                  0;

                padding:
                  18mm;

                box-shadow:
                  none;
              }

              .receipt-table tr {
                page-break-inside:
                  avoid;
              }

              img {
                page-break-inside:
                  avoid;
              }

              .signature-wrapper {
                page-break-inside:
                  avoid;
              }
            }

          </style>

        </head>


        <body>


          <!-- =====================
               PRINT BUTTON
          ===================== -->

          <div class="topbar">

            <button
              class="print-button"
              onclick="window.print()"
            >
              🖨 Print
            </button>

          </div>


          <!-- =====================
               A4 PAPER
          ===================== -->

          <div class="paper">


            <!-- HEADER -->

            <div class="header">

              <img
                src="/static/logo140.png"
                class="logo"
                alt="Leon Gallery"
              />

              <div class="contact">

                <p>
                  <b>
                    www.leon-gallery.com
                  </b>
                </p>

                <p>
                  leongallerymakati@gmail.com
                </p>

                <p>
                  info@leon-gallery.com
                </p>

              </div>

            </div>


            <!-- TITLE -->

            <div class="document-title">
              ACKNOWLEDGEMENT RECEIPT
            </div>


            <!-- INFO -->

            <div class="info">

              <div class="info-row">

                <div class="info-label">
                  Name:
                </div>

                <div class="info-value">
                  ${escapeHtml(
                    customerName
                  )}
                </div>

              </div>


              <div class="info-row">

                <div class="info-label">
                  Auction:
                </div>

                <div class="info-value">
                  ${escapeHtml(
                    eventName
                  )}
                </div>

              </div>


              <div class="info-row">

                <div class="info-label">
                  Date:
                </div>

                <div class="info-value">
                  ${escapeHtml(
                    dateStart
                  )}
                </div>

              </div>


              <div class="info-row">

                <div class="info-label">
                  Commission:
                </div>

                <div class="info-value">
                  ${(
                    commissionRate *
                    100
                  ).toFixed(2)}%
                </div>

              </div>

            </div>


            <!-- DESCRIPTION -->

            <div class="description">

              <span class="indent">

                This is to acknowledge
                the receipt of full
                payment for
                <b>
                  ${escapeHtml(
                    customerName
                  )}
                </b>
                's Commission for the
                item/s consigned by
                <b>
                  ${escapeHtml(
                    consignedName
                  )}
                </b>
                to Leon Gallery for
                <b>
                  ${escapeHtml(
                    eventName
                  )}
                </b>
                held last
                ${escapeHtml(
                  dateStart
                )}
                at G/F Eurovilla 1,
                Rufino corner Legazpi
                Streets, Legazpi Village,
                Makati City.

              </span>

            </div>


            <!-- TABLE -->

            <table
              class="receipt-table"
            >

              <thead>

                <tr>

                  <th
                    style="width:10%"
                  >
                    Lot #
                  </th>

                  <th
                    style="width:18%"
                  >
                    Image
                  </th>

                  <th
                    style="width:47%"
                  >
                    Details
                  </th>

                  <th
                    style="width:25%"
                  >
                    Hammer Price
                  </th>

                </tr>

              </thead>


              <tbody>

                ${lotRows}

              </tbody>


              <tfoot>


                <!-- SUB TOTAL -->

                <tr>

                  <td
                    colspan="3"
                    class="summary-label"
                  >
                    Sub Total
                  </td>

                  <td
                    class="summary-value"
                  >
                    ${formatMoney(
                      totalSub
                    )}
                  </td>

                </tr>


                <!-- COMMISSION -->

                <tr>

                  <td
                    colspan="3"
                    class="summary-label"
                  >
                    Seller's Commission
                    (
                    ${(
                      commissionRate *
                      100
                    ).toFixed(2)}
                    %)
                  </td>

                  <td
                    class="summary-value"
                  >
                    ${formatMoney(
                      commissionAmount
                    )}
                  </td>

                </tr>


                <!-- TOTAL -->

                <tr>

                  <td
                    colspan="3"
                    class="total-label"
                  >
                    Total Due
                  </td>

                  <td
                    class="total-value"
                  >
                    ${formatMoney(
                      commissionAmount
                    )}
                  </td>

                </tr>

              </tfoot>

            </table>


            <!-- SIGNATURE -->

            <div
              class="signature-wrapper"
            >

              <div
                class="signature"
              >

                <div
                  style="
                    min-height:22px;
                    font-size:10px;
                    margin-bottom:5px;
                  "
                >
                  ${escapeHtml(
                    customerName
                  )}
                </div>

                <div
                  class="signature-line"
                >

                  <div
                    class="signature-label"
                  >
                    Signature over
                    printed name
                  </div>

                </div>

              </div>

            </div>


            <!-- ADDRESS -->

            <div
              class="address"
            >

              <p>
                G/F Eurovilla 1,
                Rufino Corner Legazpi
                Streets,
              </p>

              <p>
                Legazpi Village,
                Makati City
              </p>

              <p>
                Philippines
              </p>

              <p>
                Tel no. (632)
                856-2781
              </p>

            </div>


          </div>


        </body>

      </html>
    `);

    printWindow.document.close();

    printWindow.focus();
  };

  return (
    <Box className={classes.root}>

      <Grid
        container
        spacing={3}
      >

        {/* =====================
            LOT NUMBERS
        ===================== */}

        <Grid
          item
          lg={4}
          md={5}
          xs={12}
        >
          <Card
            className={classes.card}
          >

            <Box
              className={
                classes.sectionHeader
              }
            >

              <Box
                display="flex"
                alignItems="center"
              >

                <Box
                  className={
                    classes.headerIcon
                  }
                >
                  <ReceiptIcon
                    fontSize="small"
                  />
                </Box>

                <Box>

                  <Typography
                    variant="h6"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Lot Numbers
                  </Typography>

                  <Typography
                    variant="body2"
                    className={
                      classes.sectionSubtitle
                    }
                  >
                    Enter lot numbers
                    line by line
                  </Typography>

                </Box>

              </Box>

            </Box>


            <Divider />


            <CardContent
              className={
                classes.content
              }
            >

              <TextField
                multiline
                rows={12}
                fullWidth
                variant="outlined"
                className={
                  classes.lotField
                }
                placeholder={
                  "1\n2\n3"
                }
                value={lotNumberData.replace(
                  /,/g,
                  "\n"
                )}
                onChange={(e) => {
                  const lots =
                    e.target.value.replace(
                      /\n/g,
                      ","
                    );

                  handleLotInput({
                    target: {
                      value: lots,
                    },
                  });
                }}
              />


              <Box
                className={
                  classes.lotCount
                }
              >
                {data1.length} lot
                {data1.length !==
                1
                  ? "s"
                  : ""}{" "}
                loaded
              </Box>

            </CardContent>

          </Card>
        </Grid>


        {/* =====================
            DETAILS
        ===================== */}

        <Grid
          item
          lg={8}
          md={7}
          xs={12}
        >
          <Card
            className={classes.card}
          >

            <Box
              className={
                classes.sectionHeader
              }
            >

              <Box
                display="flex"
                alignItems="center"
              >

                <Box
                  className={
                    classes.headerIcon
                  }
                >
                  <PersonIcon
                    fontSize="small"
                  />
                </Box>

                <Box>

                  <Typography
                    variant="h6"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Commission Details
                  </Typography>

                  <Typography
                    variant="body2"
                    className={
                      classes.sectionSubtitle
                    }
                  >
                    Enter the commission
                    information
                  </Typography>

                </Box>

              </Box>

            </Box>


            <Divider />


            <CardContent
              className={
                classes.content
              }
            >

              {/* EVENT */}

              <Autocomplete
                options={
                  geteventList
                }
                getOptionLabel={(
                  option
                ) =>
                  option.auction_name ||
                  ""
                }
                value={
                  geteventList.find(
                    (item) =>
                      item.id ===
                      eventId
                  ) || null
                }
                onChange={
                  handlepick
                }
                renderInput={(
                  params
                ) => (
                  <TextField
                    {...params}
                    label="Event"
                    variant="outlined"
                    fullWidth
                    className={
                      classes.field
                    }
                    InputProps={{
                      ...params.InputProps,
                      startAdornment:
                        (
                          <>
                            <EventIcon
                              fontSize="small"
                              style={{
                                marginRight: 8,
                                color:
                                  "#9ca3af",
                              }}
                            />

                            {
                              params
                                .InputProps
                                .startAdornment
                            }
                          </>
                        ),
                    }}
                  />
                )}
              />


              {/* COMMISSION NAME */}

              <TextField
                fullWidth
                label="Commission Name"
                variant="outlined"
                className={
                  classes.field
                }
                value={
                  customerName
                }
                onChange={(e) =>
                  setName(
                    e.target.value
                  )
                }
                placeholder="Enter commission name"
              />



              {/* COMMISSION RATE */}

              <TextField
                fullWidth
                label="Commission Rate"
                type="number"
                variant="outlined"
                className={
                  classes.field
                }
                value={
                  commission
                }
                onChange={(e) =>
                  setCommission(
                    parseFloat(
                      e.target.value ||
                        0
                    )
                  )
                }
                inputProps={{
                  min: 0,
                  step: 0.001,
                }}
                helperText={`Commission: ${(
                  commissionRate *
                  100
                ).toFixed(2)}%`}
              />


              {/* =====================
                  SUMMARY
              ===================== */}

              <Box
                className={
                  classes.summaryBox
                }
              >

                <Typography
                  variant="body2"
                  className={
                    classes.summaryTitle
                  }
                >
                  Commission Summary
                </Typography>


                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Lots
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    {
                      data1.length
                    }
                  </span>

                </Box>


                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Hammer Subtotal
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    {formatMoney(
                      totalSub
                    )}
                  </span>

                </Box>


                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Commission Rate
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    {(
                      commissionRate *
                      100
                    ).toFixed(2)}
                    %
                  </span>

                </Box>


                <Box
                  className={
                    classes.totalRow
                  }
                >

                  <span
                    className={
                      classes.totalLabel
                    }
                  >
                    Commission Total
                  </span>

                  <span
                    className={
                      classes.totalValue
                    }
                  >
                    {formatMoney(
                      commissionAmount
                    )}
                  </span>

                </Box>

              </Box>

            </CardContent>


            <Divider />


            {/* =====================
                ACTION
            ===================== */}

            <Box
              className={
                classes.actionSection
              }
            >

              <Button
                variant="contained"
                color="primary"
                className={
                  classes.previewButton
                }
                startIcon={
                  <VisibilityIcon />
                }
                onClick={
                  handlePrintPreview
                }
              >
                Preview & Print
              </Button>

            </Box>

          </Card>
        </Grid>

      </Grid>


      {/* =========================
          LOADING
      ========================= */}

      <Backdrop
        className={
          classes.backdrop
        }
        open={loading}
      >
        <CircularProgress
          color="inherit"
        />
      </Backdrop>

    </Box>
  );
};

export default Views;